import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const CashPaymentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 0 0;
  width: 100%;
`

export const CashPaymentLabel = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #999999;
  text-align: center;
  margin: 0;
`

export const PriceDisplay = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
`

export const PriceValue = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 30px;
  font-weight: 700;
  line-height: 36px;
  color: #262626;
  margin: 0;
`

export const DiscountBadge = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: #14b8aa;
  border-radius: 200px;
  padding: 2px 8px;
  height: 20px;
`

export const DiscountIcon = styled.div`
  width: 12px;
  height: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
`

export const DiscountText = styled.span`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  color: #ffffff;
`

export const ValidityText = styled.p`
  font-family: 'Inter', 'Montserrat', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  color: #999999;
  text-align: center;
  margin: 0;
  width: 100%;
`

export const ButtonWrapper = styled.div`
  width: 100%;
  margin-top: 16px;

  ${theme.breakpoints.down('md')} {
    display: none;
  }
`
